import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, Drawer, IconButton, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LocationSearch from './LocationSearch/LocationSearch';
import { CustomDialog, dialogStyles } from './SelectLocationDialog.styles';
import { CenterLocation } from 'types/location';
interface ISelectLocationDialogProps {
  open: boolean;
  locations: CenterLocation[] | undefined;
  handleClose: () => void;
  dataTestId?: string;
  preSelectedLocation?: CenterLocation;
}
interface ILocationModalBodyProps {
  locations: CenterLocation[] | undefined;
  handleClose: () => void;
  preSelectedLocation?: CenterLocation;
}
function LocationModalBody({
  handleClose,
  locations,
  preSelectedLocation
}: ILocationModalBodyProps) {
  return <>
			<DialogTitle sx={dialogStyles.dialogTitle} id="dialog-title" data-test-id="dialog-title" data-sentry-element="DialogTitle" data-sentry-source-file="SelectLocationDialog.tsx">
				<Typography variant="bodyLargeBold" data-sentry-element="Typography" data-sentry-source-file="SelectLocationDialog.tsx">Select a location</Typography>
				<IconButton aria-label="close" onClick={handleClose} sx={dialogStyles.closeButton} data-test-id="close-button" data-sentry-element="IconButton" data-sentry-source-file="SelectLocationDialog.tsx">
					<CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="SelectLocationDialog.tsx" />
				</IconButton>
			</DialogTitle>

			<LocationSearch locations={locations || []} handleClose={handleClose} preSelectedLocation={preSelectedLocation} data-sentry-element="LocationSearch" data-sentry-source-file="SelectLocationDialog.tsx" />
		</>;
}
const SelectLocationDialog = ({
  open,
  handleClose,
  locations,
  dataTestId = 'select-location-dialog',
  preSelectedLocation
}: ISelectLocationDialogProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return isMobile ? <Drawer anchor="bottom" open={open} onClose={handleClose} data-test-id={dataTestId} role="dialog" aria-labelledby="dialog-title" data-sentry-element="Drawer" data-sentry-component="SelectLocationDialog" data-sentry-source-file="SelectLocationDialog.tsx">
			<LocationModalBody locations={locations} handleClose={handleClose} preSelectedLocation={preSelectedLocation} data-sentry-element="LocationModalBody" data-sentry-source-file="SelectLocationDialog.tsx" />
		</Drawer> : <CustomDialog open={open} onClose={handleClose} data-test-id={dataTestId} aria-labelledby="dialog-title" aria-modal="true" data-sentry-element="CustomDialog" data-sentry-component="SelectLocationDialog" data-sentry-source-file="SelectLocationDialog.tsx">
			<LocationModalBody locations={locations} handleClose={handleClose} data-sentry-element="LocationModalBody" data-sentry-source-file="SelectLocationDialog.tsx" />
		</CustomDialog>;
};
export default SelectLocationDialog;